export enum CategoryType {
    Car = 0,
    Special = 1,
    Motorbike = 2,
}